module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-module"
  }, [_c('form', {
    staticClass: "search-form search-form-expanded",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'open': _vm.openSuggestion
    },
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectionVal),
      expression: "selectionVal"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search...",
      "autocomplete": "off",
      "name": "query"
    },
    domProps: {
      "value": (_vm.selectionVal)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.enter.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up.apply(null, arguments)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.selectionVal = $event.target.value
      }, _vm.change],
      "blur": _vm.hide
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn submit-search",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon-magnifier",
    staticStyle: {
      "margin-top": "3px"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.noMatchesFound()) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.notFound))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matches), function(suggestion, index) {
    return _c('li', {
      class: {
        'active': _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.suggestionClick(suggestion)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(suggestion.participant_name))])])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43e24df0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/Autocomplete.vue
// module id = 1623
// module chunks = 1